import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import {
	CircularProgress,
	IconButton,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	useTheme
} from '@mui/material';
import { ITheme } from 'types/theme';
import { AuthMethodRoute } from 'constants/routes';
import React from 'react';

interface IAuthMethodsListItem {
	icon: React.ReactNode;
	onClick: () => any;
	selected: boolean;
	authMethod: AuthMethodRoute;
	loading: boolean;
	disabled?: boolean;
	useDisabledArrow?: boolean;
}

const AuthMethodListItem: React.FC<IAuthMethodsListItem> = ({
	icon,
	onClick,
	selected,
	authMethod,
	loading,
	disabled,
	useDisabledArrow
}) => {
	const itemName = intl.tr(`pages.authMethods.${authMethod}.title`);
	const theme = useTheme<ITheme>();

	return (
		<ListItem
			title={itemName}
			onClick={onClick}
			data-testid={`auth-method-list-item-${authMethod}`}
			secondaryAction={
				<IconButton edge="end" aria-label={itemName}>
					<ChevronRightOutlined
						color={useDisabledArrow ? 'disabled' : 'primary'}
						fontSize="small"
					/>
				</IconButton>
			}
			disablePadding
		>
			<ListItemButton
				style={disabled ? { color: theme.palette.text.disabled } : {}}
				divider
				selected={selected}
				sx={{
					py: 1
				}}
			>
				<ListItemIcon>{icon}</ListItemIcon>
				<ListItemText primary={itemName} />
				{loading && (
					<CircularProgress
						size={20}
						sx={{
							ml: 1
						}}
					/>
				)}
			</ListItemButton>
		</ListItem>
	);
};

AuthMethodListItem.defaultProps = {
	disabled: false,
	useDisabledArrow: false
};

export default AuthMethodListItem;
